import { ReactNode, useEffect, useRef, useState } from "react";
import { useGetMenuCtegoriesQuery, useGetMenuListQuery, useRemoveCategoryMutation, useRemoveMenuItemMutation, useUpdateCompanyByIdMutation, useUpdateMenuItemActivityMutation, useUpdateMenuOrderListMutation } from "../../../../../../API/authApi";
import { IMyMenuProps } from "./myMenu";
import { BusinessTypes, CatygoryActionTypes, ICategoryAction, ICategoryItem, IMenuItemActions, IMenuViewAction, MenuItemActionTypes, MenuListContentTypes, MyMenuContentTypes } from "../../../../../../Interfaces/componentTypes";
import CreateMenu from "./Create/createMenu";
import useDialogHooks from "../../../../../../Components/Dialog/dialog-hooks";
import CreateCategoryDialog from "../../Dialogs/CreateCategoryDialog/createCategoryDialog";
import DeleteCategory from "../../Dialogs/DeleteCategory/deleteCategory";
import CreateMenuDialog from "../../Dialogs/CreateMenuItem/createMenuDialog";
import { IMenuItemResponce, IMenuListItem } from "../../../../../../Interfaces/responseTypes";
import EditCategoryDialog from "../../Dialogs/EditCategory/editCategoryDialog";
import { IRemoveCategory, IUpdateCompanyById, IUpdateMenuItemActive, IUpdateMenuItemOrderList } from "../../../../../../Interfaces/request-interfaces";
import EditMenuItem from "../../Dialogs/EditMenuItem/editMenuItem";
import DeleteMenuItem from "../../Dialogs/DeleteMenuItem/deleteMenuItem";
import ViewMenu from "./View/viewMenu";
import { AddSquare, CardTrash, Edit, MyMenu, NoViewSvg, OpenSvg, Preview, Styling } from "../../../../../../Assets/Icons";
import ItemInfoDialog from "../../Dialogs/ItemInfo/itemInfoDialog";
import MenuItemIsActive from "../../Dialogs/MenuItemIsActive/menuItemIsActive";
import useLanguagesHooks from "../../../../../../Components/Languages/setLanguage-hooks";
import MenuTemplates from "./MenuTemplates/menuTemplates";
import { useNoAuthHooks, useToastify } from "../../../../../../Hooks/hooks";

const useMyMenuHooks = (props: IMyMenuProps) => {
    const { companyTitle, company_id } = props;
    const { data: Categories, isLoading: categoryLoading, refetch: refetchCategories } = useGetMenuCtegoriesQuery({ business_type: BusinessTypes.RESTAURANT, company_id: props.company_id });
    const { data: menuList, isLoading: menuLoading, refetch: refetchMenuList } = useGetMenuListQuery(company_id);
    const [remove, { isLoading: deleteLoading, isSuccess: deleteSuccess, isError: deleteError }] = useRemoveCategoryMutation();
    const [removeMenuItem, { isLoading: deleteMenuItemLoading, isSuccess: deleteMenuItemSuccess, isError: deleteMenuItemError }] = useRemoveMenuItemMutation();
    const [updateCompany, { isSuccess: updateSuccess, isError: updateError, isLoading: updateLoading }] = useUpdateCompanyByIdMutation();
    const [updateItemOrderList, { isLoading: itemOrderListLoading, isSuccess: itemOrderSuccess, isError: itemOrderError }] = useUpdateMenuOrderListMutation();
    const [updateIsActive, { isLoading: itemIsActiveLoading, isSuccess: itemIsActiveSuccess, isError: itemIsActiveError }] = useUpdateMenuItemActivityMutation();
    const [activeContent, setActiveContent] = useState<MyMenuContentTypes>(MyMenuContentTypes.MY_MENU);
    const { open, onOpen, onClose } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode>(<></>);
    const [menuListType, setMenuListType] = useState<MenuListContentTypes>(MenuListContentTypes.CATEGORIES);
    const [categoryItems, setCategoryItems] = useState<ICategoryItem | null>()
    const initCategoryOrderList = menuList?.map((el) => el.category.id)
    const initItemOrderList = categoryItems?.data ? categoryItems?.data.items.map((el) => el.id) : [];
    const [categoryOrderList, setCategoryOrderList] = useState<number[] | []>(initCategoryOrderList!);
    const [itemOrderList, setItemOrderList] = useState<number[] | []>(initItemOrderList!);
    const [isCategoryOrderListChanged, setIsCategoryOrderListChanged] = useState<boolean>(false);
    const [isItemOrderListChanged, setIsItemOrderListChange] = useState<boolean>(false);
    const { t } = useLanguagesHooks();
    const { largeScreen } = useNoAuthHooks();
    const { showToastSuccess, showToastError } = useToastify();
    const navRef = useRef<HTMLDivElement>(null);
    const navItemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleNavClick = (index: number, id: MyMenuContentTypes) => {
        if (id === MyMenuContentTypes.PREVIEW) {
            window.open(`/${companyTitle!.replace(" ", '')}/menu/${company_id!}`, '_blank')
        } else {
            setActiveContent(id);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const currentUrl = window.location.href.split('?')[0];
            window.history.pushState({}, '', `${currentUrl}?tab=${id}`);

            if (navItemRefs.current[index] && navRef.current && !largeScreen) {
                navItemRefs.current[index]?.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'nearest'
                });
            }
        }
    };

    const onCategoryOrderChange = (updatedOrder: number[]) => {
        setCategoryOrderList(updatedOrder)
    };

    const onMenuItemOrderChange = (updatedOrder: number[]) => {
        setItemOrderList(updatedOrder);
    };


    useEffect(() => {
        if (categoryItems?.data.items.length) {
            const initCategoryOrderList = categoryItems.data.items?.map((el) => el.id)
            setItemOrderList(initCategoryOrderList!)
        } else {
            setCategoryItems(null);
            setMenuListType(MenuListContentTypes.CATEGORIES)
        }
    }, [categoryItems, menuList]);


    const updateMenuItemList = () => {
        const currentCategoryId = categoryItems?.data.category.id;
        const currentCategoryItem = menuList?.find((item) => item.category.id === currentCategoryId);
        const categoryData: ICategoryItem = {
            data: currentCategoryItem!,
            title: categoryItems?.title!
        };
        if (categoryData.data) {
            setCategoryItems(categoryData);

        } else {
            setCategoryItems(null);
            setMenuListType(MenuListContentTypes.CATEGORIES)
        }
    };

    useEffect(() => {
        const initCategoryOrderList = menuList?.map((el) => el.category.id)
        setCategoryOrderList(initCategoryOrderList!)
        if (categoryItems) {
            updateMenuItemList()
        }
    }, [menuList]);

    useEffect(() => {
        if (menuListType === MenuListContentTypes.CATEGORIES) {
            setCategoryItems(null);
            setItemOrderList([]);
            scrollTop();
        }
    }, [menuListType]);

    useEffect(() => {
        const hasOrderChanged = JSON.stringify(categoryOrderList) !== JSON.stringify(initCategoryOrderList);
        setIsCategoryOrderListChanged(hasOrderChanged)
    }, [categoryOrderList]);

    useEffect(() => {
        if (itemOrderList && itemOrderList.length > 0) {
            const hasOrderChanged = JSON.stringify(itemOrderList) !== JSON.stringify(initItemOrderList);
            setIsItemOrderListChange(hasOrderChanged)
        }
    }, [itemOrderList]);


    useEffect(() => {
        if (deleteSuccess) {
            showToastSuccess(t('Toast.Success.Category_Remove'));
            refetchCategories();
            refetchMenuList();
            onClose();
        } else if (deleteError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [deleteSuccess, deleteError]);

    const onDelete = (id: number) => {
        const payload: IRemoveCategory = {
            category_id: id,
            company_id: props.company_id
        }
        remove(payload)
    };

    const onDeleteMenuItem = (id: number) => {
        removeMenuItem(id)
    };

    const handleItemIsActive = (categoryId: number, data: IMenuItemResponce) => {
        const payload: IUpdateMenuItemActive = {
            company_id: props.company_id,
            category_id: categoryId,
            menu_item_id: data.id,
            is_active: !data.is_active
        }
        updateIsActive(payload)
    };

    useEffect(() => {
        if (itemIsActiveSuccess) {
            onClose();
            refetchMenuList();

        } else if (itemIsActiveError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [itemIsActiveSuccess, itemIsActiveError]);

    useEffect(() => {
        if (deleteMenuItemSuccess) {
            showToastSuccess(t('Toast.Success.Item_Remove'));
            refetchMenuList();
            onClose();
        } else if (deleteMenuItemError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [deleteMenuItemSuccess, deleteMenuItemError]);

    useEffect(() => {
        if (updateSuccess) {
            refetchMenuList()
        } else if (updateError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [updateSuccess, updateError]);

    const onUpdateCategoryOrderList = () => {
        const payload: IUpdateCompanyById = {
            id: props.company_id,
            data: {
                order_list: categoryOrderList
            }
        };
        updateCompany(payload)
    };


    const updateTemplateWithJson = async (templateJson: string) => {
        const payload: IUpdateCompanyById = {
            id: props.company_id,
            data: {
                styles: templateJson, // Send the JSON string directly
            }
        };

        try {
            await updateCompany(payload).unwrap();
            // cb(props.company_id); // Use a special ID to indicate JSON template
            props.onUpdate();

            showToastSuccess(t('Toast.Success.Common'));
        } catch (error) {
            showToastError(t('Toast.Error.Common'))
        }
    };

    const onUpdateItemOrderList = () => {
        const payload: IUpdateMenuItemOrderList = {
            company_id: props.company_id,
            category_id: categoryItems?.data.category.id!,
            order_list: itemOrderList
        };
        updateItemOrderList(payload)
    };

    useEffect(() => {
        if (itemOrderSuccess) {
            refetchMenuList()
        } else if (itemOrderError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [itemOrderSuccess, itemOrderError]);

    const onOpenDeleteCategoryDialog = (id: number, title: string) => {
        onOpen();
        setDialogComponent(
            <DeleteCategory
                id={id}
                title={title}
                onClose={onClose}
                onDelete={onDelete}
                loading={deleteLoading}
            />
        )
    };

    const onOpenCreateTemplateDialog = () => {
        onOpen();
        setDialogComponent(
            <CreateCategoryDialog
                onClose={onClose}
                cb={refetchCategories}
                company_id={props.company_id}
            />)
    };

    const onOpenAddMenuItemDialog = (companyId: number, categoryId: number, title: string) => {
        onOpen();
        setDialogComponent(
            <CreateMenuDialog
                title={title}
                onClose={onClose}
                cb={refetchMenuList}
                companyId={companyId}
                categoryId={categoryId}
            />
        )
    };

    const onSetMenuItemList = (data: IMenuListItem, title: string) => {
        const categoryData: ICategoryItem = {
            data: data,
            title: title
        };
        setMenuListType(MenuListContentTypes.ITEMS);
        setCategoryItems(categoryData);
        scrollTop();
    };

    const onOpenMenuItemInfoDialog = (categoryId: number, data: IMenuItemResponce, title: string) => {
        onOpen()
        setDialogComponent(
            <ItemInfoDialog
                data={data}
                title={title}
                currencySymbol={props.currencySymbol}
            />
        )
    };


    const onMainView = () => {
        setMenuListType(MenuListContentTypes.CATEGORIES)
        setActiveContent(MyMenuContentTypes.MY_MENU)
        scrollTop()
    };

    const categoryActions: ICategoryAction[] = [
        {
            type: CatygoryActionTypes.ADD,
            icon: AddSquare,
            onClick: (data: IMenuListItem, title: string) => {
                onOpen()
                setDialogComponent(
                    <CreateMenuDialog
                        title={title}
                        onClose={onClose}
                        cb={refetchMenuList}
                        categoryId={data.category.id}
                        companyId={props.company_id}
                    />
                )
            }
        },
        {
            type: CatygoryActionTypes.EDIT,
            icon: Edit,
            onClick: (data: IMenuListItem, title: string) => {
                onOpen()
                setDialogComponent(
                    <EditCategoryDialog
                        title={title}
                        onClose={onClose}
                        data={data.category}
                        cb={refetchMenuList}
                        compnay_id={props.company_id}
                    />
                )
            }
        },
        {
            type: CatygoryActionTypes.OPEN,
            icon: OpenSvg,
            onClick: onSetMenuItemList
        },
        {
            type: CatygoryActionTypes.DELETE,
            icon: CardTrash,
            onClick: (data: IMenuListItem, title: string) => {
                onOpen()
                setDialogComponent(
                    <DeleteCategory
                        title={title}
                        onClose={onClose}
                        onDelete={onDelete}
                        id={data.category.id}
                        loading={deleteLoading}
                    />
                )
            }
        },
    ];

    const menuItemActions: IMenuItemActions[] = [
        {
            type: MenuItemActionTypes.EDIT,
            icon: Edit,
            onClick: (categoryId: number, data: IMenuItemResponce, title: string) => {
                onOpen()
                setDialogComponent(
                    <EditMenuItem
                        data={data}
                        title={title}
                        onClose={onClose}
                        cb={refetchMenuList}
                        category_id={categoryId}
                        company_id={props.company_id}
                    />
                )
            }
        },
        {
            type: MenuItemActionTypes.OPEN,
            icon: OpenSvg,
            onClick: onOpenMenuItemInfoDialog
        },
        {
            type: MenuItemActionTypes.VIEW,
            icon: NoViewSvg,
            onClick: (categoryId: number, data: IMenuItemResponce, title: string) => {
                onOpen();
                setDialogComponent(
                    <MenuItemIsActive
                        title={title}
                        onClick={() => handleItemIsActive(categoryId, data)}
                        onClose={onClose}
                        loading={itemIsActiveLoading}
                    />
                )
            }
        },
        {
            type: MenuItemActionTypes.DELETE,
            icon: CardTrash,
            onClick: (categoryId: number, data: IMenuItemResponce, title: string) => {
                onOpen()
                setDialogComponent(
                    <DeleteMenuItem
                        id={data.id}
                        onClose={onClose}
                        title={title}
                        onDelete={onDeleteMenuItem}
                        loading={deleteMenuItemLoading}
                    />
                )
            }
        },
    ];

    const myMenuActions: IMenuViewAction[] = [
        {
            title: t('My_Business.My_Menu'),
            icon: MyMenu,
            id: MyMenuContentTypes.MY_MENU,
        },
        {
            title: t('Buttons.Edit'),
            icon: Edit,
            id: MyMenuContentTypes.EDIT_Menu,
        },
        {
            title: t('My_Business.UI_Templates'),
            icon: Styling,
            id: MyMenuContentTypes.STYLING,
        },
        {
            title: t('My_Business.Preview'),
            icon: Preview,
            id: MyMenuContentTypes.PREVIEW,
        }
    ];

    const PAGE_CONTENTS = {
        [MyMenuContentTypes.MY_MENU]:
            (
                <ViewMenu
                    menu={menuList!}
                    menuLoading={menuLoading}
                    contentType={menuListType}
                    companyId={props.company_id}
                    itemOrderList={itemOrderList}
                    categoryItems={categoryItems!}
                    setContentType={setMenuListType}
                    companyTitle={props.companyTitle!}
                    categoryOrderList={categoryOrderList}
                    onSetMenuItemList={onSetMenuItemList}
                    onOpenMenuItemInfoDialog={onOpenMenuItemInfoDialog}
                    setActiveContent={setActiveContent}
                />
            ),
        [MyMenuContentTypes.STYLING]: (
            <MenuTemplates
                activeTemplate={props.template}
                onUpdateTemplateWithJson={updateTemplateWithJson}
                updateLoading={updateLoading}
                companyTitle={props.companyTitle}
            />
        ),
        [MyMenuContentTypes.EDIT_Menu]:
            (
                <>
                    <CreateMenu
                        menu={menuList}
                        menuLoading={menuLoading}
                        categories={Categories}
                        contentType={menuListType}
                        companyId={props.company_id}
                        itemOrderList={itemOrderList}
                        itemActions={menuItemActions}
                        categoryItems={categoryItems!}
                        setContentType={setMenuListType}
                        categoryLoading={categoryLoading}
                        categoryActions={categoryActions}
                        categoryOrderList={categoryOrderList}
                        orderListUodateLoading={updateLoading}
                        menuItemOrderLoading={itemOrderListLoading}
                        onMenuItemOrderChange={onMenuItemOrderChange}
                        onCategoryOrderChange={onCategoryOrderChange}
                        isItemOrderListChange={isItemOrderListChanged}
                        onUpdateMenuItemOrderList={onUpdateItemOrderList}
                        onUpdateCategoryOrderList={onUpdateCategoryOrderList}
                        isCategoryOrderListChanged={isCategoryOrderListChanged}
                        onOpenAddMenuItemDialog={onOpenAddMenuItemDialog}
                        onOpenCreateTemplateDialog={onOpenCreateTemplateDialog}
                        onOpenDeleteCategoryDialog={onOpenDeleteCategoryDialog}
                        handleItemIsActive={handleItemIsActive}
                        onBack={onMainView}
                    />
                </>),
        [MyMenuContentTypes.PREVIEW]: (
            <></>
        )
    };

    return {
        open,
        navRef,
        navItemRefs,
        PAGE_CONTENTS,
        activeContent,
        myMenuActions,
        dialogComponent,
        onClose,
        handleNavClick,
    }
};

export default useMyMenuHooks